<template>
  <div class="c-table" ref="targetingTable">
    <el-table
      class="common-el-table-styles"
      ref="table"
      v-loading="loading"
      :data="data"
      :height="height"
      border
      stripe
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <!--系统生成的定向包不允许任何操作，系统管理员Id=1-->
          <div v-else-if="col.key === 'control' && scope.row.createOpId !== 1">
            <Poptip confirm transfer title="您确认删除该定向包吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small" class="c-control-margin">删除</el-button>
            </Poptip>
            <el-button type="text" size="small" @click="copyClick(scope.row)" class="c-control-margin">复制</el-button>
            <el-button type="text" size="small" @click="editClick(scope.row)" class="c-control-margin">修改</el-button>
          </div>
          <div v-else-if="col.key === 'targetingName'">
            <!-- @on-popper-show="$emit('on-loadAudiues', [scope.row, scope.$index])" -->
            <Poptip
              trigger="hover"
              placement="top-start"
              transfer
              popper-class="target-tooltip"
              @on-popper-show="scope.row.mediaId === 6 ? showAudience(scope.row) : null"
            >
              <el-button type="text">{{ scope.row['targetingName'] }}</el-button>
              <div class="target-wrap" slot="content">
                <header>
                  <dl>{{ scope.row['targetingName'] }}</dl>
                  <dl>ID: {{ scope.row['targetingId'] }}</dl>
                </header>
                <div class="target-content">
                  <Spin size="large" v-if="ucTargetsLoading"></Spin>
                  <ul v-if="scope.row['targets']">
                    <template v-for="(item, id) in scope.row['targets']">
                      <li v-if="!item.hide" :key="id">
                        <dt>{{ item.name }}：</dt>
                        <dd v-if="item.all">不限</dd>
                        <dd v-else>
                          <span v-for="(ret, i) in item.values" :key="i"> {{ i ? '、' : '' }}{{ ret }} </span>
                        </dd>
                      </li>
                    </template>
                  </ul>
                  <ul v-else>
                    <template v-for="(item, index) in scope.row['ucTargets']">
                      <li :key="index" v-if="item.isShow">
                        <dt>{{ item.name }}：</dt>
                        <dd>{{ item.value }}</dd>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </Poptip>
          </div>
          <span v-else-if="['pv', 'clickNum', 'amount'].includes(col.key)">
            {{ scope.row[col.key] | toThousands }}
          </span>
          <span v-else-if="col.key.indexOf('Rate') > -1 || col.key.indexOf('Roi') > -1">
            {{ scope.row[col.key] | toPercentFixed }}
          </span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
import { getAudience } from '@/api/uc.model'

import { ucCompile } from '@/common/js/ucCompile'
import uccityData from '@/data/uc/city_province'
import ucgategoryData from '@/data/uc/app_categroy'
import ucinterestData from '@/data/uc/interest_data'
import ucuPlusData from '@/data/uc/uplus_data'

export default {
  name: 'targetingTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    },
    summary: {
      type: Object
    },
    type: {
      type: String
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    editClick(row) {
      const { targetingId } = row
      const mediaId = row.mediaId
      switch (mediaId) {
        case 10:
          this.$router.push({ name: 'ToutiaoTargetingAdd', query: { targetingId, t: 'edit' } })
          break
        case 16:
          this.$router.push({ name: 'tartencentadd', query: { targetingId, t: 'edit' } })
          break
        case 32:
          this.$router.push({ name: 'tarkuaishouadd', query: { targetingId, t: 'edit' } })
          break
        case 45:
          this.$router.push({ name: 'tarbaiduadd', query: { targetingId, t: 'edit' } })
          break
        case 6:
          this.$router.push({ name: 'tarUCadd', query: { targetingId, t: 'edit' } })
          break
      }
    },
    copyClick(row) {
      const { targetingId } = row
      const mediaId = row.mediaId
      switch (mediaId) {
        case 10:
          this.$router.push({ name: 'ToutiaoTargetingAdd', query: { targetingId, t: 'copy' } })
          break
        case 16:
          this.$router.push({ name: 'tartencentadd', query: { targetingId, t: 'copy' } })
          break
        case 32:
          this.$router.push({ name: 'tarkuaishouadd', query: { targetingId } })
          break
        case 45:
          this.$router.push({ name: 'tarbaiduadd', query: { targetingId } })
          break
        case 6:
          this.$router.push({ name: 'tarUCadd', query: { targetingId } })
          break
      }
    },
    doLayout() {
      this.$refs.table.doLayout()
    },
    showAudience(row) {
      this.ucTargetsLoading = true
      getAudience({ ad_account_id: Number(row.accountIds) }).then((ret) => {
        this.$nextTick(() => {
          this.ucOriginData.audienceData = ret
          const json = ucCompile(row.targetingParamJson, this.ucOriginData)
          this.$set(row, 'ucTargets', json)
          this.ucTargetsLoading = false
        })
      })
    }
  },
  data() {
    return {
      ucTargetsLoading: false,
      ucOriginData: {
        cityData: uccityData,
        gategoryData: ucgategoryData,
        interestData: ucinterestData,
        uPlusData: ucuPlusData,
        audienceData: []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  background-color: #fff;

  .c-control-margin {
    margin: 0;
    padding-right: 6px;
  }
}

.target-tooltip {
  position: relative;
  background: #ff6600;

  .target-close {
    position: absolute;
    top: 18px;
    right: 12px;
  }

  .target-wrap {
    width: 280px;

    header {
      width: inherit;
      padding: 8px 0 8px 8px;
      border-bottom: solid 1px #dedede;

      dl {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 1.2;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin: 0;
      }
    }

    .target-content {
      overflow-y: auto;
      scrollbar-width: thin;
      -webkit-overflow-scrolling: touch;
      padding: 8px 0 8px 4px;
      width: 100%;
      max-height: 318px;

      ul {
        margin: 0;
      }

      li {
        padding-top: 6px;
        display: flex;

        dd,
        dt {
          line-height: 18px;
          display: inline-block;
          margin: 0;
        }

        dt {
          color: #333;
          font-weight: 600;
        }

        dd {
          max-width: 230px;
          word-break: break-all;
          white-space: normal;
          color: #888;
        }
      }
    }
  }
}
</style>
